var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartupIncoporated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.4995,
    r: 40.5,
    fill: "#D5D6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4438 38.507H56.9593L53.2016 33.6131L49.4438 38.507ZM49.4438 43.401H56.9593L53.2016 48.2949L49.4438 43.401Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 26.2722H35.6655V55.6359H28.15C27.8178 55.6359 27.4992 55.507 27.2643 55.2775C27.0294 55.0481 26.8975 54.7369 26.8975 54.4124V27.4957C26.8975 27.1712 27.0294 26.86 27.2643 26.6306C27.4992 26.4011 27.8178 26.2722 28.15 26.2722Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1709 26.2722H45.6864C46.0186 26.2722 46.3372 26.4011 46.5721 26.6306C46.807 26.86 46.939 27.1712 46.939 27.4957V54.4124C46.939 54.7369 46.807 55.0481 46.5721 55.2775C46.3372 55.507 46.0186 55.6359 45.6864 55.6359H38.1709V26.2722Z",
    fill: "#2E3192"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0619,
    height: 29.3636,
    fill: "white",
    transform: "translate(26.8975 26.2722)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupIncoporated);
export default __webpack_public_path__ + "static/media/startupIncoporated.938d0d7c02cc6f161b8a9a75753c11f4.svg";
export { ForwardRef as ReactComponent };